import { type Signal, signal } from '@angular/core';

import { DEFAULT_SPINNER_DELAY_MS } from './common.constant';

export class DelayedSpinner {
  private isActive = false;
  private delayTimeoutId: ReturnType<typeof setTimeout> | null = null;
  private readonly isActiveVisibleState = signal(false);

  constructor(
    private readonly delayMs: number = DEFAULT_SPINNER_DELAY_MS,
  ) {}

  get valueSignal(): Signal<boolean> {
    return this.isActiveVisibleState.asReadonly();
  }

  dispose(): void {
    this.setActive(false);
  }

  setActive(active: boolean): void {
    if (!active) {
      this.isActive = false;
      this.clearDelay();
      this.isActiveVisibleState.set(false);

      return;
    }

    this.isActive = true;
    this.clearDelay();
    this.isActiveVisibleState.set(false);

    this.delayTimeoutId = setTimeout(() => {
      this.delayTimeoutId = null;

      if (!this.isActive) {
        return;
      }

      this.isActiveVisibleState.set(true);
    }, this.delayMs);
  }

  private clearDelay(): void {
    if (!this.delayTimeoutId) {
      return;
    }

    clearTimeout(this.delayTimeoutId);
    this.delayTimeoutId = null;
  }
}
